export const LOGIN_OPTIONS = [
  { value: 'DISABLED', labelId: 'ui-tenant-settings.settings.emailSettings.loginOptions.disabled' },
  { value: 'NONE', labelId: 'ui-tenant-settings.settings.emailSettings.loginOptions.none' },
  { value: 'REQUIRED', labelId: 'ui-tenant-settings.settings.emailSettings.loginOptions.required' },
  { value: 'XOAUTH2', labelId: 'ui-tenant-settings.settings.emailSettings.loginOptions.xoauth2' },
];

export const TLS_OPTIONS = [
  { value: 'DISABLED', labelId: 'ui-tenant-settings.settings.emailSettings.TLSOptions.disabled' },
  { value: 'OPTIONAL', labelId: 'ui-tenant-settings.settings.emailSettings.TLSOptions.optional' },
  { value: 'REQUIRED', labelId: 'ui-tenant-settings.settings.emailSettings.TLSOptions.required' },
];

export const MODULE_NAME = 'TENANT';
export const CONFIG_NAME = 'email.smtp.configuration';